import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BookingSubscription } from '@store';

@Component({
  selector: 'app-booking-unregistered-list',
  templateUrl: './booking-unregistered-list.component.html',
  styleUrls: ['./booking-unregistered-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BookingUnregisteredListComponent {
  @Input() unregisteredSubscriptions: BookingSubscription[];
}
